import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

function plClass(value) {
    const n = Number(value);
    if (Number.isNaN(n) || n === 0) return '';
    return n > 0 ? 'positive' : 'negative';
}

const Strategy = (props) => {
    const list = props.list || [];
    if (!list.length) {
        return null;
    }

    return (
        <section className="stock-card">
            <div className="stock-card-body">
                <h2 className="stock-section-title">
                    <Translate value="stock_strategy" />
                </h2>
                <div className="stock-strategy-list">
                    {list.map((item, index) => (
                        <div key={item.reference || index} className="stock-strategy-row">
                            <span className="stock-strategy-ref">{item.reference || '—'}</span>
                            <span className={`stock-strategy-pl ${plClass(item.pl)}`}>
                                {item.pl != null ? `$ ${Number(item.pl).toFixed(2)}` : '—'}
                                <small> USD</small>
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

Strategy.propTypes = {
    className: PropTypes.string,
};

function mapStateToProps(reducer) {
    return {
        list: reducer.stockNews.listStrategy,
    };
}

export default connect(mapStateToProps)(Strategy);
